import React, { useState } from 'react'
import Allproducts from '../../Index/tab/Allproducts'

const BestSeller = () => {
    const [active, setActive] = useState("allProducts")

    const products = [
        {
            prod: 'All Products',
            active: "allProducts"
        },
        {
            prod: 'Best Sellers',
            active: "bestSellers"
        },
    ]

    const handleActiveClick = (index) => {
        setActive(index)
    }

    const tab = [
        { product: <Allproducts /> },
        { product: "COMING SOON" }

    ]
    const activeIndex = products.findIndex(item => item.active === active);

    return (
        <div>
            <div className='flex flex-col gap-4'>
                <div className='flex flex-row gap-4 border-b-[1px] border-blue-400'>
                    {
                        products.map((p, i) => {
                            return (
                                <div key={i} onClick={() => handleActiveClick(p.active)} className={`flex cursor-pointer text-white text-[20px] text-opacity-75 ${active === p.active ? "border-b-2 border-blue-400 text-blue-500" : ""}`}>
                                    <p>{p.prod}</p>
                                </div>
                            )
                        })
                    }
                </div>
                <div className=''>
                    {tab[activeIndex].product}
                </div>
            </div>

        </div>
    )
}

export default BestSeller